import { useTheme } from "@mui/material/styles";
import { black, white } from "designSystem/styles/color";
import { Box, FlexRowCenter, Grid, Link, Text } from "designSystem/index";
import React, { FunctionComponent, ReactElement } from "react";
import Component, { ComponentProps } from "./Component";

export interface PaneProps {
	components: ComponentProps[];
	imports?: string;
	muiApi?: string;
	muiComponent?: string;
	title: string;
}

export function paneComponent(
	name: string,
	code: string,
	func: () => ReactElement,
	notes?: string,
	className?: string,
): ComponentProps {
	return { className, code, func, name, notes };
}

/**
 * Component to render all examples of a design system component (i.e. Button)
 */
const Pane: FunctionComponent<PaneProps> = (props) => {
	const { components, imports, muiApi, muiComponent, title } = props;
	const { palette } = useTheme();

	return (
		<Box
			height={1}
			overflow="auto"
			p={3}
			width={1}
		>
			<Grid
				container
				direction="column"
				spacing={6}
			>
				<Grid item>
					<Grid
						alignItems="center"
						container
						spacing={4}
					>
						<Grid item>
							<Text text={title} variant="h2" />
						</Grid>
						{muiComponent && (
							<Grid item>
								<FlexRowCenter>
									<Link href={`https://material-ui.com/components/${muiComponent}`} target="MUI">
										<Text
											semiBold
											size={16}
											text="Material UI"
										/>
									</Link>
									{muiApi && (
										<Box
											border={`2px solid ${palette.LinkDefault}`}
											display="inline-block"
											ml={1}
											px={1}
											py={0.5}
										>
											<Link href={`https://material-ui.com/api/${muiApi}`} target="MUIAPI">
												<Text bold text="API" />
											</Link>
										</Box>
									)}
								</FlexRowCenter>
							</Grid>
						)}
					</Grid>
				</Grid>
				{imports && (
					<Grid item>
						<Box
							bgcolor={black[100]}
							borderRadius="3px"
							color={white[50]}
							component="code"
							display="inline-block"
							my={1}
							p={2}
						>
							<Text
								size={13}
								text={imports}
								variant="inherit"
							/>
						</Box>
					</Grid>
				)}
				{
					components.map((comp) => (
						<Grid item key={comp.name}>
							<Component {...comp} />
						</Grid>
					))
				}
			</Grid>
		</Box>
	);
};

export default Pane;